export const PageHeader = ({ title, display }) => {
  // return display ? (
  //   <div className="app-page-header">
  //     <h3 className="mb-0 mr-3 font-weight-semibold" style={{ minWidth: "230px" }}>
  //       <IntlMessage id={title ? title : "home"} />
  //     </h3>
  //     <AppBreadcrumb />
  //   </div>
  // ) : null;
  return null;
};

export default PageHeader;
